import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

const SHELL = { maxWidth: 900, margin: "0 auto", width: "calc(100% - 48px)" };

export function LegalLayout({ title, updated, children }) {
  return (
    <div style={{ background: "linear-gradient(180deg,#FBF8F2 0%,#F6F2EA 100%)", minHeight: "100vh" }}>
      <header style={{ borderBottom: "1px solid rgba(110,31,42,.10)", background: "var(--paper)" }}>
        <div style={{ maxWidth: 1240, margin: "0 auto", width: "calc(100% - 48px)", height: 82, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Link to="/" aria-label="DDP inicio" style={{ display: "flex", alignItems: "center" }}><Logo height={40} /></Link>
          <Link to="/" data-testid="legal-back" style={{ display: "inline-flex", alignItems: "center", gap: 7, color: "var(--burgundy-dark)", textDecoration: "none", fontSize: 14, fontWeight: 700 }}>
            <ArrowLeft size={16} /> Volver al inicio
          </Link>
        </div>
      </header>

      <main style={{ ...SHELL, padding: "clamp(36px,6vw,72px) 0" }}>
        <div className="ddp-eyebrow" style={{ marginBottom: 20 }}>Información legal</div>
        <h1 className="ddp-serif" style={{ fontSize: "clamp(30px,4vw,46px)", color: "var(--burgundy-dark)", margin: 0, letterSpacing: "-.02em", lineHeight: 1.12 }}>{title}</h1>
        {updated && <p style={{ color: "var(--muted)", fontSize: 13.5, marginTop: 12 }}>{updated}</p>}
        <div className="ddp-card" style={{ padding: "clamp(24px,4vw,44px)", marginTop: 28 }}>{children}</div>
      </main>

      <footer style={{ borderTop: "1px solid var(--line)", background: "var(--paper)" }}>
        <div style={{ maxWidth: 1240, margin: "0 auto", width: "calc(100% - 48px)", padding: "30px 0", display: "flex", flexWrap: "wrap", gap: 18, alignItems: "center", justifyContent: "space-between" }}>
          <Logo height={34} />
          <nav style={{ display: "flex", flexWrap: "wrap", gap: 22, fontSize: 13 }}>
            <Link to="/aviso-legal" style={{ color: "var(--muted)", textDecoration: "none", fontWeight: 600 }}>Aviso legal</Link>
            <Link to="/privacidad" style={{ color: "var(--muted)", textDecoration: "none", fontWeight: 600 }}>Política de privacidad</Link>
            <Link to="/cookies" style={{ color: "var(--muted)", textDecoration: "none", fontWeight: 600 }}>Política de cookies</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}

export const H2 = ({ children }) => (
  <h2 className="ddp-serif" style={{ fontSize: 22, color: "var(--burgundy-dark)", margin: "32px 0 10px", letterSpacing: "-.01em" }}>{children}</h2>
);
export const P = ({ children }) => (
  <p style={{ fontSize: 14.5, lineHeight: 1.72, color: "#3D3834", margin: "0 0 12px" }}>{children}</p>
);
export const UL = ({ children }) => (
  <ul style={{ margin: "0 0 14px", paddingLeft: 20, fontSize: 14.5, lineHeight: 1.72, color: "#3D3834" }}>{children}</ul>
);
